/** @module Supplier/ProductSalesRegionSpecMatrix */
define([
	"dojo/_base/declare",
	"csi/heading/Spec",
	"csi/store/Nodes",
	"csi/table/matrix/_Processor",
	"csi/xml/Query"
], function(declare, Spec, Nodes, _Processor, Query) {

	return declare(_Processor, {
		/** @property {Nodes} _productSalesRegionSpecStore - Data store of the Product Sales Region Specification nodes */
		_productSalesRegionSpecStore: null,

		addDeferred: function(ctx, h, dfds) {
			this._productSalesRegionSpecStore = new Nodes({
				sortQuery: new Query().SortByAttr("SortOrder"),
				typeNode: "ProductSalesRegionSpec"
			});

			dfds.push(this._productSalesRegionSpecStore.query());
		},

		getColumnSpecs: function(ctx, h) {
			return this._productSalesRegionSpecStore.query().map(function(columnNode) {
				// C8-4487: Use ProductSalesRegionSpec.SysID as the indices
				return new Spec({
					index: columnNode.SysID,
					heading: h,
					headerParams: {
						innerText: columnNode.$Name
					}
				});
			});
		}
	});
});